import Content from "../../../components/Content"
import TeamMember from "../../../components/TeamMember"
import { useAppSelector } from "../../../store/store"

const TeamMembersPage = () => {
    const team = useAppSelector(state => state.team)

    return (
        <Content className="flex flex-col gap-5">
            <p className="text-zinc-700 text-2xl">Miembros</p>
            {team.team_members?.map((member) => (
                <TeamMember key={member.id} teamMember={member} />
            ))}
        </Content>
    )
}

export default TeamMembersPage